import $ from "jquery";
import "summernote/dist/summernote-bs5.min.js";

/**
 * Automatically initializes `Summernote` instances for elements with the `data-summernote` attribute.
 */
export function initializeSummernote(): void {
    $(() => {
        $("[data-summernote]").each(function () {
            const id = $(this).attr("id");
            if (id) {
                activateSummernote(id);
            }
        });
    });
}

/**
 * Activates a `Summernote` editor for a specific element.
 * @param {string} id - The ID of the element to initialize as a `Summernote` editor.
 */
export function activateSummernote(id: string): void {
    const element = $(`#${id}`);

    // Extract custom attributes
    const height = element.data("height");
    const minHeight = element.data("minHeight") ?? null;
    const maxHeight = element.data("maxHeight") ?? null;
    const focus = element.data("focus") ?? false;
    const allowImages = element.data("allega-img") ?? false;
    const allowVideos = element.data("allega-video") ?? false;

    (element as any).summernote({
        lang: "it-IT",
        height: height || 300, // Set editor height with fallback
        minHeight: minHeight || 100, // Set minimum height of editor with fallback
        maxHeight: maxHeight || 500, // Set maximum height of editor with fallback
        focus: focus || false, // Set focus to editable area after initializing
        tooltip: false,
        callbacks: {
            onInit: function () {
                const editor = $(this).next(".note-editor");
    
                // Remove image and video buttons if not allowed
                if (!allowImages) {
                    editor.find(".note-insert .note-btn:nth-child(2)").remove();
                    if (!allowVideos) {
                        editor.find(".note-insert .note-btn:nth-child(2)").remove();
                    }
                }
                if (!allowVideos) {
                    editor.find(".note-insert .note-btn:nth-child(3)").remove();
                }
    
                // Update Bootstrap 5 compatibility for dropdowns
                editor.find('.note-btn[data-toggle]').each(function () {
                    const dataToggle = $(this).attr("data-toggle") ?? "";
                    $(this).attr("data-bs-toggle", dataToggle);
                    $(this).removeAttr("data-toggle");
                });
    
                // Add icons to dropdown buttons
                editor.find(".note-btn-group.note-fontname .note-btn.dropdown-toggle").append('&nbsp;<i class="bi bi-caret-down"></i>');
                editor.find(".note-btn-group.note-color .note-btn.dropdown-toggle").append('<i class="bi bi-caret-down"></i>');
                editor.find(".note-btn-group.note-color .note-btn.dropdown-toggle").css("padding", "0");
    
                // Set initial content from the original input
                const originalValue = $(this).val();
                $(`#${id} ~ .note-editor .note-editable`).html(String(originalValue || ""));
                $(this).css("display", "").attr("type", "hidden");
            },
            onChange: function (contents: string) {
                $(this).val(contents);
            },
        },
    });
}